module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-RegularItalic.8e08dc27.woff";